import React from 'react';
import { Folder, Upload } from 'lucide-react';

interface KnowledgeEmptyStateProps {
  onUploadClick: () => void;
  selectedType: string | null;
}

export function KnowledgeEmptyState({ onUploadClick, selectedType }: KnowledgeEmptyStateProps) {
  
  let subtitleText = "Upload your first PDF, DOCX, or CSV file to give Finn deeper context on your product and customers.";
  if (selectedType === 'pdf') {
    subtitleText = "Upload your first PDF file to give Finn deeper context on your product and customers.";
  } else if (selectedType === 'docx') {
    subtitleText = "Upload your first DOCX file to give Finn deeper context on your product and customers.";
  } else if (selectedType === 'csv') {
    subtitleText = "Upload your first CSV file to give Finn deeper context on your product and customers.";
  }

  return (
    <div style={{ 
      display: 'flex', 
      flexDirection: 'column', 
      alignItems: 'center', 
      justifyContent: 'center',
      minHeight: '400px',
      border: '1px solid var(--admin-card-border)',
      borderRadius: '0',
      backgroundColor: 'transparent'
    }}>
      <div style={{ color: '#EAB308', marginBottom: '20px' }}>
        <Folder size={28} strokeWidth={1.5} />
      </div>

      <h2 style={{ 
        fontFamily: "'Space Grotesk', sans-serif",
        color: 'var(--admin-card-text)', 
        fontSize: '20px', 
        fontWeight: 700, 
        margin: '0 0 12px 0',
        lineHeight: '28px',
        letterSpacing: '-0.48px',
        textAlign: 'center'
      }}>
        No documents yet
      </h2>
      
      <p style={{ 
        fontFamily: "'Inter', sans-serif",
        color: '#7C8891', 
        fontSize: '13px', 
        fontWeight: 400, 
        margin: '0 0 24px 0', 
        maxWidth: '400px', 
        textAlign: 'center', 
        lineHeight: '18px',
        letterSpacing: '0'
      }}>
        {subtitleText}
      </p>

      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <button 
          onClick={onUploadClick}
          style={{ 
            display: 'flex', 
            alignItems: 'center', 
            gap: '8px', 
            padding: '10px 16px', 
            borderRadius: '0', 
            fontSize: '12px', 
            fontWeight: 700, 
            border: 'none', 
            cursor: 'pointer', 
            backgroundColor: 'var(--admin-card-text)', 
            color: 'var(--admin-bg-container, #010204)', 
            transition: 'opacity 0.2s' 
          }}
          className="hover:opacity-90"
        >
          <Upload size={14} /> Upload First Document
        </button>
      </div>
    </div>
  );
}
